import { useLocation, Navigate } from 'react-router-dom';
import { Box, Card, CardActions, CardContent } from '@mui/material';
import '../styles/UploadPage.css';
import failedImage from '../../../img/failed_mark.png';
import SelectPhotoButton from '../../../shared/components/ui/buttons/SelectPhotoButton';
import selectPhotoButton_img1 from '../../../img/select_photo_button.png'; // 写真を撮る選ぶアイコン
import ViewAllButton from '../../../shared/components/ui/buttons/ViewAllButton';

const UploadFailed = () => {
    const location = useLocation();
    const fromUpload = location.state?.fromUpload;

    if (!fromUpload) {
    return <Navigate to="/auth/login" replace />;
    }

    return (
        <Box className="upload-section">
            <Card
                className="upload-card"
                sx={{
                    bgcolor: 'rgba(255, 255, 255, 0.5)', // カードの背景色
                    boxShadow: 'none',
                    color: 'rgb(100, 90, 70)',
                }}
            >
                <CardContent
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        padding: '8px',
                    }}
                >
                    <p className='upload-title'>Failed...</p>
                    <img src={failedImage} alt='sample-img' style={{ width: '55%', margin: '10% 0 10% 0' }} />
                    <p className='upload-process' style={{ fontWeight: 'bold', marginTop: '6%' }}>予期せぬエラーによりアップロードが</p>
                    <p className='upload-process' style={{ fontWeight: 'bold' }}>失敗しました...</p>
                    <p className='upload-process' style={{ fontWeight: 'bold', marginBottom: '6%' }}>お手数ですが再度お試しください。</p>
                </CardContent>

                <CardActions
                    sx={{
                        padding: '8px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <SelectPhotoButton imageUrl={selectPhotoButton_img1} />
                </CardActions>
            </Card>
            <CardActions>
                <ViewAllButton />
            </CardActions>
        </Box>
    );
};

export default UploadFailed;
